import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "forget-password" }
const _hoisted_2 = { class: "forget-password-card" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "content"
}
const _hoisted_5 = { class: "content-item" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "content-item" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = {
  key: 1,
  class: "content"
}
const _hoisted_13 = {
  key: 2,
  class: "content"
}

import { getCaptchaApi } from "@/api/captcha/captchaApi";
import { sendResetPasswordEmailApi } from "@/api/manager/managerApi";
import { SendResetPasswordEmailParams } from "@/types/validator";
import { some } from "lodash-es";
import { onMounted, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPasswordView',
  setup(__props) {

const captchaUrl = ref<string>("");
const { locale } = useI18n();
const refreshCaptcha = async () => {
  const response = await getCaptchaApi();
  console.log(response);
  if (response) {
    console.log(response);
    sendEmailParams.captchaId = response.captchaId;
    captchaUrl.value = response.captchaImage; // 时间戳防止缓存
  } else {
    console.error("获取验证码失败");
  }
};

// 发送验证码
const sendEmailParams = reactive<SendResetPasswordEmailParams>({
  email: "",
  captchaId: "",
  verCode: "",
  locale: locale.value,
});

const result = ref<boolean | null>(null);
const sendingEmail = ref<boolean>(false);
const sendEmail = async () => {
  const flag = !some(sendEmailParams, (value) => {
    // 检查是否为 null、undefined 或者 trim() 结果为空字符串
    return value == null || (typeof value === "string" && value.trim() === "");
  });
  if (flag) {
    sendingEmail.value = true;
    const response = await sendResetPasswordEmailApi(sendEmailParams);
    sendingEmail.value = false;
    console.log(response);
    result.value = response;
  }
};

onMounted(() => {
  refreshCaptcha();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_result = _resolveComponent("el-result")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "logo" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.$t("r.resetPassword")), 1)
      ]),
      (result.value == null)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("resetPass.email")), 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_input, {
                  modelValue: sendEmailParams.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sendEmailParams.email) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("resetPass.captcha")), 1),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_input, {
                  modelValue: sendEmailParams.verCode,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sendEmailParams.verCode) = $event)),
                  style: {"width":"60%","margin-right":"10px"}
                }, null, 8, ["modelValue"]),
                _createElementVNode("img", {
                  src: captchaUrl.value,
                  alt: _ctx.$t('resetPass.changeCaptcha'),
                  class: "captcha-image",
                  onClick: refreshCaptcha
                }, null, 8, _hoisted_11)
              ])
            ]),
            _createVNode(_component_el_button, {
              type: "primary",
              class: "submit",
              color: "#f332e3",
              onClick: sendEmail,
              onKeyup: _withKeys(sendEmail, ["enter"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("resetPass.submit")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_link, {
              type: "primary",
              class: "returnLogin",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/login')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("resetPass.returnLogin")), 1)
              ]),
              _: 1
            })
          ])), [
            [_directive_loading, sendingEmail.value]
          ])
        : (result.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_el_result, {
                icon: "success",
                title: _ctx.$t('resetPass.success.title'),
                "sub-title": _ctx.$t('resetPass.success.tip')
              }, null, 8, ["title", "sub-title"])
            ]))
          : (!result.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_el_result, {
                  icon: "error",
                  title: _ctx.$t('resetPass.fail.title'),
                  "sub-title": _ctx.$t('resetPass.fail.tip')
                }, {
                  extra: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (result.value = null))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("resetPass.back")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["title", "sub-title"])
              ]))
            : _createCommentVNode("", true)
    ])
  ]))
}
}

})